var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTest(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.87,
    height: 29.469,
    viewBox: "0 0 21.87 29.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.04,
    y1: 2.516,
    x2: 0.259,
    y2: -0.717,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#405cfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab5fc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-result-3265903",
    d: "M149.312,0a.921.921,0,0,0-.925.925V4.145a.921.921,0,0,0,.925.919h7.655a.921.921,0,0,0,.917-.919V.924A.921.921,0,0,0,156.967,0Zm-6.187,1.612a.921.921,0,0,0-.924.925V28.552a.921.921,0,0,0,.924.917h20.028a.921.921,0,0,0,.917-.917V2.536a.921.921,0,0,0-.917-.925h-3.427V4.149a2.791,2.791,0,0,1-2.752,2.757h-7.655a2.792,2.792,0,0,1-2.773-2.757V1.611Zm10.015,8.374a7.4,7.4,0,1,1-7.4,7.4A7.41,7.41,0,0,1,153.139,9.985Zm0,1.842a5.554,5.554,0,1,0,5.554,5.554A5.54,5.54,0,0,0,153.139,11.827Zm3.011,2.982a.921.921,0,0,1,.5,1.674l-4.576,3.3a.921.921,0,0,1-1.3-.225l-1.38-1.984a.921.921,0,1,1,1.509-1.054l.849,1.223,3.82-2.746a.922.922,0,0,1,.484-.184c.029,0,.059,0,.088,0Z",
    transform: "translate(-142.2 0.001)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.ea59ba5609ea01e14ecf8fef4dde58ba.svg";
export { ForwardRef as ReactComponent };